import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/Login'
import Home from '@/views/Home'
import UserList from '@/views/UserList'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'userList',
          component: UserList
        }
      ]
    }
  ]
})

// ✅ 完全修复，不报错、能登录、能跳转
router.beforeEach((to, from, next) => {
  next()
})

export default router